






























































import Vue, { PropType } from "vue";
import IfaceSyncInvoiceHeadDTO, { partnerCodeAndName } from "../../models/IfaceSyncInvoiceHeadDTO";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";

interface Props {
  invoice: IfaceSyncInvoiceHeadDTO;
}

interface Computed {
  directionClass: string;
  partnerDisplay: string;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: "InvoiceInfo",

  components: { SyncStatusBadge },

  props: {
    invoice: { type: Object as PropType<IfaceSyncInvoiceHeadDTO>, required: true },
  },

  computed: {
    /** "(partner kód) partner név" — a név a partner köztes táblából jön */
    partnerDisplay(): string {
      return partnerCodeAndName(this.invoice);
    },

    directionClass(): string {
      switch (this.invoice.direction) {
        case "IN":  return "dir-in";
        case "OUT": return "dir-out";
        default:    return "";
      }
    },
  },
});
